{
  "LetsGetStarted": "¿Buscas una forma de convertir tus ideas en realidad? ¡Empecemos!",
  "CreateFirstProject": "Crear mi primer proyecto",
  "My Group Builder Schedule": "Calendario de builders de mi grupo",
  "My Group Builders": "Builders de mi grupo",
  "My Builders": "Mis builders",
  "Explore Projects": "Explorar proyectos",
  "Explore Builders": "Explorar builders",
  "Whoops!": "Whoops!",
  "NeedToFirstCreateProject": "Para poder empezar un builder necesitas crear un proyecto primero",
  "WouldYouLikeToCreate": "¿Te gustaría crear uno ahora?",
  "CreateNewProject": "Crear nuevo proyecto",
  "Due Today": "Para hoy",
  "Past Due": "Pasado",
  "Due": "Due",
  "Notifications": "Notificaciones",
  "MarkAsRead": "Marcar todo como leído",
  "ExploreBuildersTooltip": "Explora Builders que te ayuden a poner en marcha tus ideas",
  "ExploreProjectsTooltip": "Inspírate con los proyectos de otras personas",
  "MyGroupBuildersTooltip": "Sigue de cerca los builders que te han asignado en un grupo",
  "MyGroupBuilderScheduleTooltip": "Sigue de cerca el calendario de builders que has asignado a los grupos donde eres admin/manager",
  "MyBuildersTooltip": "Sigue de cerca los Builders en los que estás trabajando",
  "Difficulty Level": "Nive de dificultad",
  "textOne": "¡Crea tu primer proyecto y empieza a explorar RebelBase! También puedes colabroar, interactuar, hacer equipo y compartir ideas con otros Rebels.",
  "textTwo": "Te animamos a trabajar usando nuestros Builders y Workshops en la plataforma para que puedas construir tu proyecto.",
  "textThree": "No te preocupes si no tienes claro qué tipo de proyecto quieres construir en este momento. Empeiza con una idea y te ayudaremos a refinarlo. También puedes unirte a un equipo, o a otro proyectos en tu Hub.",
  "ReadyToTurnIdeasToReality": "¿Buscas una forma de convertir tus ideas en realidad? ¡Empecemos!",
  "InnovationCannotWait": "La innovación no puede esperar. Crea tu primer proyecto y descubrirás cómo podemos ayudarte a construir algo juntos.",
  "SkipForNow": "Saltar por ahora"
}
